import ApiRequest from "utils/ApiRequest"
import apiConfig from "../utils/ApiConfig";

export default class Author {
  static getAll = async () => {
    return await ApiRequest.set("v1/authors/getall-authors", "GET")
  }

  static getById = async (id) => {
    return await ApiRequest.set(`v1/authors/getbyid/${id}`, "GET")
  }

  static getAllWithPagination = async (limit, page, keyword) => {
    return await ApiRequest.set(`v1/authors/search-authors-by-name-with-pagination-filter-for-admin?limit=${limit}&page=${page}&keyword=${keyword}&sort_by`, "GET")
  }

  static create = async (body) => {
    return await ApiRequest.set("v1/authors/create-authors", "POST", body)
  }

  static edit = async (id, body) => {
    return await ApiRequest.set(`v1/authors/update-authors-byid/${id}`, "PUT", body)
  }

  static delete = async (id) => {
    return await ApiRequest.set(`v1/authors/delete/${id}`, "DELETE")
  }

  static bulkUpload = async (file, dryRun = false) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return await ApiRequest.setMultipart(`v1/authors/bulk-upload${dryRun ? '?dry_run=true' : ''}`, 'POST', formData);
  }

  static downloadTemplate = async () => {
    const token = localStorage.getItem('super_token') || localStorage.getItem('token');
    const response = await fetch(`${apiConfig.base_url}v1/authors/bulk-template`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : null,
      },
    });
    if (!response.ok) {
      let errorMessage = 'Failed to download template';
      try {
        const err = await response.json();
        errorMessage = err?.error_message || err?.message || errorMessage;
      } catch (e) {
      }
      throw new Error(errorMessage);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'author_bulk_template.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}